import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Button, SvgIcon, Tooltip } from '@rossum/ui/material';
import { useIntl } from 'react-intl';

type UpdateButtonProps = {
  isUpToDate: boolean;
  updateValue: () => void;
  disabled: boolean;
};

export const UpdateButton = ({
  isUpToDate,
  updateValue,
  disabled,
}: UpdateButtonProps) => {
  const intl = useIntl();
  return isUpToDate ? (
    <Button
      variant="outlined"
      color="secondary"
      onClick={updateValue}
      disabled={disabled}
    >
      {intl.formatMessage({
        id: 'features.queueSettings.fields.formulaPreview.updateValues',
      })}
    </Button>
  ) : (
    <Tooltip
      title={
        disabled
          ? intl.formatMessage({
              id: 'features.formulas.formulaFieldSection.noSchemaId',
            })
          : intl.formatMessage({
              id: 'features.queueSettings.fields.formulaPreview.outdated',
            })
      }
    >
      <span>
        <Button
          variant="outlined"
          color="warning"
          disabled={disabled}
          startIcon={
            <SvgIcon>
              <IconAlertTriangle />
            </SvgIcon>
          }
          onClick={updateValue}
        >
          {intl.formatMessage({
            id: 'features.queueSettings.fields.formulaPreview.updateValues',
          })}
        </Button>
      </span>
    </Tooltip>
  );
};
